(function () {
  var forms = document.querySelectorAll('.sn_maincart__footer__form');
  if (!forms.length) return;

  forms.forEach(function (wrapper) {
    var form = wrapper.closest('form');
    if (!form || form.dataset.cfInit) return;
    form.dataset.cfInit = 'true';

    var formId = form.id;
    var associated = formId ? [].slice.call(document.querySelectorAll('[form="' + formId + '"]')) : [];
    function q(sel) { return form.querySelector(sel) || associated.find(function (el) { return el.matches(sel); }); }

    var els = {
      privacyCheck: form.querySelector('[id$="_checkout_privacy_submit"]'),
      cfCheck: q('[data-cf-check] input[type="checkbox"]'),
      cfInput: q('[data-cf-input]'),
      cfTextInput: form.querySelector('[name="attributes[cf]"]')
        || (formId ? document.querySelector('[form="' + formId + '"][name="attributes[cf]"]') : null),
      companyCheck: q('[data-company-check] input[type="checkbox"]'),
      companyInput: q('[data-company-input]'),
      pivaInput: form.querySelector('[name="attributes[p_iva]"]')
        || (formId ? document.querySelector('[form="' + formId + '"][name="attributes[p_iva]"]') : null),
      checkoutBtn: q('[name="checkout"]')
    };

    function toggleCf() {
      if (els.cfInput) els.cfInput.hidden = !els.cfCheck.checked;
    }
    function toggleCompany() {
      if (els.companyInput) els.companyInput.hidden = !els.companyCheck.checked;
    }
    toggleCf();
    toggleCompany();
    if (els.cfCheck) els.cfCheck.addEventListener('change', toggleCf);
    if (els.companyCheck) els.companyCheck.addEventListener('change', toggleCompany);

    function updateCheckout() {
      if (!els.checkoutBtn) return;
      var allowed = true;
      if (els.privacyCheck && !els.privacyCheck.checked) allowed = false;
      if (els.cfCheck && els.cfCheck.checked && !(els.cfTextInput && els.cfTextInput.value.trim())) allowed = false;
      if (els.companyCheck && els.companyCheck.checked && !(els.pivaInput && els.pivaInput.value.trim())) allowed = false;
      els.checkoutBtn.disabled = !allowed;
    }
    updateCheckout();
    if (els.privacyCheck) els.privacyCheck.addEventListener('change', updateCheckout);
    if (els.cfCheck) els.cfCheck.addEventListener('change', updateCheckout);
    if (els.companyCheck) els.companyCheck.addEventListener('change', updateCheckout);
    if (els.cfTextInput) els.cfTextInput.addEventListener('input', updateCheckout);
    if (els.pivaInput) els.pivaInput.addEventListener('input', updateCheckout);

    var bypass = false;
    form.addEventListener('submit', function (e) {
      if (bypass) return;
      e.preventDefault();
      var submitter = e.submitter;
      var data = { attributes: {} };
      var formEls = [].slice.call(form.elements);
      var noteEl = formEls.find(function (el) { return el.name === 'note'; });
      if (noteEl) data.note = noteEl.value;

      formEls.forEach(function (input) {
        var m = input.name.match(/^attributes\[(.+)\]$/);
        if (m && input.type !== 'checkbox') data.attributes[m[1]] = input.value;
      });

      if (els.cfCheck) {
        data.attributes.request_invoice = els.cfCheck.checked ? 'yes' : 'no';
        if (!els.cfCheck.checked) data.attributes.cf = '';
      }
      if (els.companyCheck) {
        data.attributes.is_company = els.companyCheck.checked ? 'yes' : 'no';
        if (!els.companyCheck.checked) {
          data.attributes.p_iva = '';
          data.attributes.sdi = '';
          data.attributes.pec = '';
        }
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).catch(function () {}).then(function () {
        if (els.cfCheck && !els.cfCheck.checked && els.cfTextInput) els.cfTextInput.value = '';
        if (els.companyCheck && !els.companyCheck.checked) {
          if (els.pivaInput) els.pivaInput.value = '';
          var sdi = form.querySelector('[name="attributes[sdi]"]')
            || (formId ? document.querySelector('[form="' + formId + '"][name="attributes[sdi]"]') : null);
          var pec = form.querySelector('[name="attributes[pec]"]')
            || (formId ? document.querySelector('[form="' + formId + '"][name="attributes[pec]"]') : null);
          if (sdi) sdi.value = '';
          if (pec) pec.value = '';
        }
        bypass = true;
        if (submitter && (submitter.form === form || form.contains(submitter))) {
          form.requestSubmit(submitter);
        } else {
          form.requestSubmit();
        }
        bypass = false;
      });
    });
  });
})();
